import { companyInfo } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-navy-950 text-white">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/0a155c0b-5c7a-49b7-acc8-8ff5e038e9e9/3f3dad74-7308-46d7-8d0e-529180c03494_KakaoTalk_20260505_183028351-Photoroom.png?v=ddc88a719a372cc57fa4314903ee596a"
                alt="한국문화체육진흥원 로고"
                className="h-8 w-auto object-contain"
              />
              <div>
                <p className="font-bold text-base">{companyInfo.name}</p>
                <p className="text-[10px] text-white/60">{companyInfo.enName}</p>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              교육을 키우며, 문화를 연결하고, 미래를 함께합니다.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">연락처</h4>
            <div className="space-y-2 text-sm text-white/70">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-sky-300" />
                </div>
                <span>{companyInfo.phone}</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-smartphone-line text-sky-300" />
                </div>
                <span>{companyInfo.mobile} / {companyInfo.mobile2}</span>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-sky-300" />
                </div>
                <span>{companyInfo.email}</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">주소</h4>
            <div className="space-y-2 text-sm text-white/70">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-sky-300" />
                </div>
                <span>{companyInfo.address}</span>
              </div>
              <p className="text-xs text-white/50 mt-2">
                사업자등록번호: {companyInfo.regNumber} | 법인등록번호: {companyInfo.taxId}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#inquiry"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#inquiry')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-xs text-white/50 hover:text-sky-300 transition-colors"
            >
              문의접수
            </a>
            <a
              href={`tel:${companyInfo.phone}`}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
              aria-label="전화"
            >
              <i className="ri-phone-line text-sm" />
            </a>
            <a
              href={`mailto:${companyInfo.email}`}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
              aria-label="이메일"
            >
              <i className="ri-mail-line text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}